/*
 * Material landing pages — live prices.
 *
 * Fills every [data-ml-price] element with the editor's price for that
 * material/size/quantity, in the buyer's currency. Uses the same inputs and
 * formula as the editor (app.js recalcPrice) so the page never promises a
 * price the editor won't show:
 *   pricing table  ← /apps/signmaker/api/config (shop metafield, shop currency)
 *   rate           ← Shopify.currency.rate (the rate the Cart Transform uses)
 *   unit cost      = ((w/1000)·(h/1000)·coef + fixed·0.89^qty + add) · 1.06
 *   unit price     = cost / (1 − margin) + mount price
 * Elements stay hidden (their [data-ml-price-wrap] parent too) until a price is
 * known, so a slow or failing config request just leaves the copy without it.
 */
(function () {
  'use strict';

  var ALIASES = { aluminium: 'aluminum', alu: 'aluminum' };
  // Mandatory mounting that the editor always adds (banners only ship with eyelets).
  var FORCED_MOUNT = { banner: 3.5 };
  var CACHE_KEY = 'ml-pricing-v1';

  function loadConfig() {
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) { /* storage blocked */ }
    return fetch('/apps/signmaker/api/config', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('config ' + r.status); return r.json(); })
      .then(function (cfg) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cfg)); } catch (e) { /* ignore */ }
        return cfg;
      });
  }

  function unitPrice(mat, w, h, qty) {
    var p = mat.pricing || {};
    var cost = ((w / 1000) * (h / 1000) * (+p.coef || 0) + (+p.fixed || 0) * Math.pow(0.89, qty) + (+p.add || 0)) * 1.06;
    var margin = Math.min(0.99, Math.max(0, (+mat.marginPct || 0) / 100));
    return cost / (1 - margin);
  }

  function formatter(code) {
    var S = window.Shopify || {};
    var lang = (document.documentElement.lang || S.locale || 'en').split('-')[0];
    var locale = S.country ? lang + '-' + S.country : lang;
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: code });
    } catch (e) {
      return { format: function (n) { return code + ' ' + n.toFixed(2); } };
    }
  }

  function run() {
    var nodes = document.querySelectorAll('[data-ml-price]');
    if (!nodes.length) return;
    loadConfig().then(function (cfg) {
      var table = cfg && cfg.pricingTable && cfg.pricingTable.materials;
      if (!table) return;
      var S = window.Shopify || {};
      var shopCurrency = (cfg.pricingTable.currency || cfg.shopCurrency || 'EUR').toUpperCase();
      var code = (S.currency && S.currency.active) || shopCurrency;
      var rate = S.currency && parseFloat(S.currency.rate) > 0 ? parseFloat(S.currency.rate) : 1;
      var fmt = formatter(code);
      Array.prototype.forEach.call(nodes, function (el) {
        var id = (el.getAttribute('data-material') || '').toLowerCase();
        id = ALIASES[id] || id;
        var mat = table[id];
        var w = +el.getAttribute('data-w');
        var h = +el.getAttribute('data-h');
        var qty = Math.max(1, +el.getAttribute('data-qty') || 1);
        if (!mat || !w || !h) return;
        var each = unitPrice(mat, w, h, qty) + (FORCED_MOUNT[id] || 0);
        el.textContent = fmt.format(each * rate);
        el.hidden = false;
        // Reveal every hidden wrapper up the tree (table row and the card around it).
        var wrap = el.closest('[data-ml-price-wrap]');
        while (wrap) {
          wrap.hidden = false;
          wrap = wrap.parentElement && wrap.parentElement.closest('[data-ml-price-wrap]');
        }
      });
      document.querySelectorAll('[data-ml-currency]').forEach(function (el) { el.textContent = code; });
    }).catch(function () { /* leave prices hidden */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
